define('SageDotCom/Components/ProductCard/ProductTryButton',[
    "jquery",
    "score_bootstrap/Components/Button", 
    "SageDotCom/DataLayer/Events/product-card-detail"
], function ($, Button, ProductCardDetailEvent) {

    return function (args) {
        Button.init(args);

        // Track click on Try button -- will have a separate event
        // $(args.scope).on('click', 'a', function (e) {
        //     var originalURL = $(this).attr("href");
        //     var productService = new ProductCardDetailEvent();

        //     if (originalURL.indexOf("sku=") > -1) {
        //         productService.triggerAddToCartTealiumEvent(originalURL, args.scope);
        //     }
        // });
    };

    function getProductData() {
        // Get base product data from product card container, 
        // later we can augment it with additional properties taken from other components placed in the product card container
        var product = $(this).closest('[id^=productcardcontainer]').data('dataUxArgs').Product;
        return product ? JSON.parse(product) : null;
    }
});
